import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class DataService {

    private _messageSource = new Subject<any>();

    data = this._messageSource.asObservable();

    sendData(change: any) {
        this._messageSource.next(change);
    }
}


// WEBPACK FOOTER //
// ./src/app/vqutils/data.service.ts